/**
 * OutcomeItem Component
 *
 * A single outcome/benefit item with an icon and description.
 * Used to list what users will be able to do after learning.
 *
 * Example:
 * <OutcomeItem
 *   title="You hear a melody. You play it."
 *   description="That song stuck in your head? You sit at your instrument..."
 * />
 *
 * Used in: StartHere, all learn pages
 */

import React from "react";
import styles from "../../styles/learn/OutcomeItem.module.css";

interface OutcomeItemProps {
    icon?: string; // defaults to "→"
    title: React.ReactNode;
    children: React.ReactNode; // Description content
}

export default function OutcomeItem({ icon = "→", title, children }: OutcomeItemProps) {
    return (
        <div className={styles.outcome}>
            <div className={styles.outcomeHeader}>
                <div className={styles.outcomeIcon}>{icon}</div>
                <h3 className={styles.outcomeTitle}>{title}</h3>
            </div>
            <div className={styles.outcomeDescription}>{children}</div>
        </div>
    );
}
